import { jsx as _jsx } from "react/jsx-runtime";
import { Kind } from "@oui/lib/src/types";
import { ChatInputSingleChoice } from "./ChatInputSingleChoice";
/**
 * A `ChatInput` implementation that pauses the conversation by waiting for the
 * user to press the button to continue.
 *
 * Upon pressing, sends a `{ kind: Kind.InputButton, props: {} }` envelope.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-58}
 */ export function ChatInputButton(props) {
    return /*#__PURE__*/ _jsx(ChatInputSingleChoice, {
        label: {
            '0': props.label
        },
        onInput: function() {
            return props.onInput({
                kind: Kind.InputButton,
                props: {}
            });
        },
        variant: "button"
    });
}
